import { claimableChest, seasonFinaleState } from './game';
import type { BootstrapData } from '../api/types';

/**
 * Бейдж = «ждущие приятные решения» (спека §5): открываемый сундук + незакрытый
 * финал в первые 7 дней + pending-импорты. «День не записан» сюда НЕ входит (§2).
 */
export function computeAppBadge(data: BootstrapData, now: Date = new Date()): number {
  const chest = claimableChest(data, now) ? 1 : 0;
  const fin = seasonFinaleState(data, now);
  const finale = fin && !fin.closed && now.getDate() <= 7 ? 1 : 0;
  return chest + finale + (data.pending_count ?? 0);
}
